module.exports = __webpack_public_path__ + "img/elementheights_jak.064af7c2.png";